import { Modal, useScreenDetect } from '@sgcmpteltd/uikit-next';
import { IosArrowDown, IosArrowUp, IosClose } from '@sgcmpteltd/uikit-react';
import {
  Result,
  RESULT_VARIANT_WARNING,
} from '@sgcmpteltd/uikit-react/components/result';
import cx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';

import { useBodyScrollLock } from '@/hooks/use-body-scroll-lock';
import { joinSgcmMobileSite, joinSgcmSite } from '@/utils/url/join/public';

import {
  COLLAPSIBLE_ARRAOW_ICON_SIZE,
  COMPARISON_CAR_HEIGHT,
  COMPARISON_CAR_WIDTH,
  IOSCLOSE_SIZE,
  NUM_COMPARISON_MAX_VEHICLES,
} from './contants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const ComparisonDrawer: Component = ({
  items,
  isOpen,
  isWarningModalOpen,
  setDefaultHeight,
  comparePageLinkHref = `${joinSgcmSite('/new_cars/newcars_compare.php')}`,
  onDrawerToggleClick,
  onClearAllBtnClick,
  onCloseClick,
  onWarningModalCloseClick,
}) => {
  const { isDesktop } = useScreenDetect();
  const isDesktopMode = isDesktop();
  const CollapsibleArrowIcon = isOpen ? IosArrowDown : IosArrowUp;

  const handleOnDrawerToggleClick = () => {
    onDrawerToggleClick?.(!isOpen);
  };

  const handleOnClearAllBtnClick = () => {
    onClearAllBtnClick?.();
  };

  const handleOnCloseClick = (carId: number) => {
    onCloseClick?.(carId);
  };

  useBodyScrollLock({ isLocked: isWarningModalOpen });

  return (
    <>
      <div className={cx(
        styles.containerRoot,
        isOpen ? '' : styles.open,
        setDefaultHeight ? styles.defaultHeight : '',
      )}>
        <div className={styles.containerCompareDrawer}>
          <div className={styles.btnCompareToggle}>
            <button
              className={styles.containerCompare}
              onClick={handleOnDrawerToggleClick}>
              <div>
                Compare
                {Array.isArray(items) && items.length !== 0 ? ` (${items.length})` : ''}
              </div>
              <div className={styles.containerArrow}>
                <CollapsibleArrowIcon size={COLLAPSIBLE_ARRAOW_ICON_SIZE} />
              </div>
            </button>
          </div>
          <div className={styles.comparisonCars}>
            {Array.isArray(items) && items.map((compareCar) => {
              const {
                id,
                submodelId,
                name,
                make,
                model,
                thumbnailUrl,
              } = compareCar;
              return (
                <div
                  key={submodelId}
                  className={styles.containerComparisonCar}>
                  <Link href={`${isDesktopMode
                    ? joinSgcmSite(`/new_cars/newcars_overview.php?CarCode=${id}`)
                    : joinSgcmMobileSite(`/new_cars/overview.php?CarCode=${id}`)}`}>
                    <div className={styles.containerImageAndInfo}>
                      <Image
                        alt="comparison car image"
                        className={styles.imgCompareCar}
                        height={COMPARISON_CAR_HEIGHT}
                        src={thumbnailUrl}
                        width={COMPARISON_CAR_WIDTH} />
                      <div className={styles.containerCarInfo}>
                        <div className={styles.textCarModel}>
                          {make}
                          {' '}
                          {model}
                        </div>
                        <div className={styles.textCarLabel}>
                          {name}
                        </div>
                      </div>
                    </div>
                  </Link>
                  <div className={styles.iosCloseImage}>
                    <button
                      aria-label="Close"
                      className={styles.close}
                      onClick={() => handleOnCloseClick(submodelId)}>
                      <IosClose size={IOSCLOSE_SIZE} />
                    </button>
                  </div>
                </div>
              );
            }) }
            {Array.isArray(items) && items.length < 4
              ? (
                <span className={styles.textCompareAlert}>
                  Select car from the Search
                  results to compare.
                </span>
              )
              : null }
          </div>
          <div
            className={styles.containerCompareBtn}>
            <Link
              aria-disabled={items?.length === 0 ? 'true' : undefined}
              className={`${items?.length === 0 ? styles.compareNoCarsBtn : styles.compareCarsBtn}`}
              href={comparePageLinkHref}
              style={{ pointerEvents: items?.length === 0 ? 'none' : 'auto' }}
              tabIndex={items?.length === 0 ? -1 : 0}>
              <button>Compare Cars</button>
            </Link>
            <button
              className={styles.clearAll}
              onClick={handleOnClearAllBtnClick}>
              Clear All
            </button>
          </div>
        </div>
      </div>
      <Modal
        className={cx(
          styles.containerModal,
          styles.isSmall,
        )}
        isOpen={isWarningModalOpen}
        title={null}
        isBackdropStatic
        onClose={onWarningModalCloseClick}>
        <Result
          className={styles.containerResult}
          message={`You have reached the maximum of ${NUM_COMPARISON_MAX_VEHICLES} vehicles for comparison.\nPlease remove one of your vehicles from the list.`} // @suppress longLineCheck
          messageContainerClassName={styles.containerResultMessage}
          title="Limit Reached"
          variant={RESULT_VARIANT_WARNING} />
      </Modal>
    </>
  );
};
